import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { router } from "expo-router";

import { themes } from "@/Components/Styling/themeConfigs";

function WebFooter(): React.JSX.Element {
  const currentTheme = themes.morning;

  const currentYear = new Date().getFullYear();

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      alignItems: "center",
    },
    copyrightText: {
      fontSize: currentTheme.typography.h4.size.web,
      color: currentTheme.typography.h3.color,
      marginBottom: 5,
    },
    footerLinks: {
      flexDirection: "row",
    },
    footerLinkText: {
      fontSize: currentTheme.typography.h4.size.web,
      color: currentTheme.typography.h4.color,
      marginHorizontal: 3,
    },
  });

  const openTermsLink = (): void => {
    router.push("/(legal)/terms-of-service");
  };

  const openPrivacyLink = (): void => {
    router.push("/(legal)/privacy");
  };

  return (
    <View style={styles.container}>
      <Text style={styles.copyrightText}>
        © {currentYear} Dow Labs. All rights reserved.
      </Text>
      <View style={styles.footerLinks}>
        <TouchableOpacity onPress={openPrivacyLink}>
          <Text style={styles.footerLinkText}>Privacy Policy</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={openTermsLink}>
          <Text style={styles.footerLinkText}>Terms of Service</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

export default WebFooter;
